import { Box, CardContent, Container, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useParams } from "react-router";
import CommCard from "src/common/CommCard";
import DetailsDataShowByGrid from "src/common/DetailsDataShowByGrid";
import GoBackBtn from "src/common/GoBackBtn";
import NoDataFound from "src/common/NoDataFound";
import { useApiQuery } from "src/hooks/useApiQuery";
import { getStatusLabelInvoiceStatus } from "src/Utils/Combined";
import type { SingleExhibitorInvoiceInfo } from "../../type/exhibitorType";
import InvoiceItemTable from "./InvoiceItemTable";
import InvoiceWithMoneyReceipt from "../../MoneyReceipt/InvoiceWithMoneyReceipt";
import InvoicePaymentComm from "../../common/InvoicePaymentComm";

const ExhibitorSingleInvoice = () => {
	const { singleExhibitorInvoiceId } = useParams();
	const { data } = useApiQuery<SingleExhibitorInvoiceInfo>({
		endPoint: `/api/admin/exhibitor/invoice/${singleExhibitorInvoiceId}`,
		queryKeys: ["singleInvoice", singleExhibitorInvoiceId],
	});

	return (
		<CommCard helmetTitle='BTTF - Exhibitor Invoice information'>
			<Container sx={{ my: 3 }} maxWidth='xl'>
				<Grid container spacing={3}>
					<Grid item xs={12}>
						<GoBackBtn
							showGoBack
							showDetailsIcon
							navigateBtnName='Go To Exhibitor Details'
							navigateDetailsLink={`/exhibitor/list/${data?.exhibitor_id}`}
						/>
						{data ? (
							<>
								<CardContent>
									<Typography
										textAlign='center'
										variant='h4'
										gutterBottom
										sx={{
											marginBottom: "20px",
											textDecoration: "underline",
										}}
									>
										Exhibitor Invoice Details
									</Typography>
									<Grid
										container
										spacing={2}
										justifyContent={"center"}
									>
										<Grid item xs={12}>
											<DetailsDataShowByGrid
												fields={[
													{
														label: "Company Name",
														value: data?.user_fair_member_company_name,
													},
													{
														label: "Invoice No",
														value: data.invoice_no,
													},
													{
														label: "VAT",
														value: data.vat,
													},
													{
														label: "Discount",
														value: data.discount,
													},
													{
														label: "Invoice Date",
														value: moment(
															data.invoice_date
														).format("LL"),
													},
													{
														label: "Due Date",
														value: moment(
															data.due_date
														).format("LL"),
													},
													{
														label: "Net Total",
														value: data.net_total,
													},
													{
														label: "Sub Total",
														value: data.sub_total,
													},
													{
														label: "Due",
														value: data.due,
													},
													{
														label: "Client Payment",
														value: data?.clientPayment,
													},
													{
														label: "Status",
														value: getStatusLabelInvoiceStatus(
															data?.status
														),
													},
												]}
											/>
											<>
												{data?.invoicePayment?.length >
													0 && (
													<InvoicePaymentComm
														invoicePayment={
															data?.invoicePayment
														}
													/>
												)}
											</>
										</Grid>

										<Grid item xs={12}>
											<Box
												sx={{
													display: "flex",
													justifyContent:
														"space-between",
												}}
											>
												<Typography
													variant='h6'
													fontWeight='bold'
													gutterBottom
													sx={{
														textAlign: "center",
														textDecoration:
															"underline",
													}}
												></Typography>
												<Typography
													variant='h6'
													fontWeight='bold'
													gutterBottom
													sx={{
														textAlign: "center",
														textDecoration:
															"underline",
														margin: "0 auto",
													}}
												>
													Invoice Items
												</Typography>

												<InvoiceWithMoneyReceipt
													invoiceDetails={data}
												/>
											</Box>

											<InvoiceItemTable
												data={data.invoice_items}
											/>
										</Grid>
									</Grid>
								</CardContent>
							</>
						) : (
							<NoDataFound />
						)}
					</Grid>
				</Grid>
			</Container>
		</CommCard>
	);
};

export default ExhibitorSingleInvoice;
